<template>
  <div class="account-user-main">
    <cv-navbar/>
    <div class="accountUsers clearfix">
      <leftPanel :currentIndex='currentIndex' :showPrivacy="showPrivacy" @toTab="toTab"></leftPanel>
      <div class="right-modal fr">

        <div class="item-modal user-data bg_fff" v-show="currentIndex === 0">
          <div class="item-title">
            <span class="color_40 f_22">基本信息</span>
            <p class="fr color_red f_16 cursor_p" v-if="editUserInfoState" @click="saveUsersBasicInfo">保存</p>
            <p class="fr color_red f_16 cursor_p" @click="editUserInfoState = true" v-else><span class="iconfont iconedit-"></span> 编辑</p>
          </div>
          <div :class="[getUserInfoState?'opacity0' :'']">
            <div class="item-list avatar_url flex-c ">
              <div class="title f_14 color_40">头像</div>
              <div class="flex1">
                <div class="avatarImg pr">
                  <img :src="userInfo.avatar" alt="">
                  <template v-if="editUserInfoState">
                    <div class="edit-block pa text_center color_fff f_14 cursor_p" @click="uploadState(true)">编辑</div>
                  </template>
                </div>
              </div>
            </div>
            <div class="item-list flex-c ">
              <div class="title f_14 color_40">姓名</div>
              <div class="flex1">
                <input type="text" class="f_14" placeholder="请输入真实姓名" v-if="editUserInfoState" v-model="userInfo.name">
                <p class="f_14 color_40" v-else>{{userInfo.name}}</p>
              </div>
            </div>

            <div class="item-list flex-c ">
              <div class="title f_14 color_40">性别</div>
              <div class="flex1">
                <el-select v-model="gender" placeholder="请选择" v-if="editUserInfoState">
                  <el-option label="女" value="女"/>
                  <el-option label="男" value="男"/>
                </el-select>
                <!-- <input type="text" class="f_14" placeholder="请输入真实姓名" v-if="editUserInfoState" v-model="userInfo.name"> -->
                <p class="f_14 color_40" v-else>{{gender || '未填写'}}</p>
              </div>
            </div>
            <div class="item-list flex-c ">
              <div class="title f_14 color_40">求职身份</div>
              <div class="flex1">
                <el-select v-model="identify" placeholder="请选择" v-if="editUserInfoState">
                  <el-option label="职场人" value="already_work"/>
                  <el-option label="学生" value="student"/>
                </el-select>
                <!-- <input type="text" class="f_14" placeholder="请输入真实姓名" v-if="editUserInfoState" v-model="userInfo.name"> -->
                <p class="f_14 color_40" v-else>{{identify === 'already_work' ? '职场人' : identify === 'student' ? '学生' : '未填写'}}</p>
              </div>
            </div>

          </div>

        </div>

        <account-setting v-show="currentIndex === 1"></account-setting>

        <account-privacy v-show="currentIndex === 2"></account-privacy>

        <account-order v-show="currentIndex === 3"></account-order>

        <equipment-management v-show="currentIndex === 4"></equipment-management>

      </div>
      <!-- 上传插件 -->
      <portrait @uploadState="uploadState" @uploadConfirm="uploadConfirm" :maxImgSize="2*1024*1024" v-if="showUploadState" ></portrait>
    </div>
  </div>
</template>

<script>
  import { uuid } from 'vue-uuid';
  // 左侧菜单
  import leftPanel from './components/leftPanel';

  // 个人中心账号设置
  import AccountSetting from './components/AccountSetting'
  // 个人中心隐私设置
  import AccountPrivacy from './components/AccountPrivacy'
  // 个人中心我的订单
  import AccountOrder from './components/AccountOrder'
  // 个人中心设备管理
  import EquipmentManagement from './components/equipmentManagement'
  // 上传图片
  import portrait from '~/components/block/portrait';

  import cvNavbar from '@/components/base/navbar';

  import api from '@/api';
  import {mapGetters, mapActions, mapState} from 'vuex'
  import { auth, routerTo, get_tUser, dataURLtoBlob, blobToFile} from '@/assets/js/util';
  const oss = require('ali-oss');
  let ossTimeName = null //oss定时器
  export default {
    name: 'accountUsers',
    data () {
      return {
        userInfoBackup:{ //用户基本信息-备份
          avatar:'',
        },
        userInfo:{ //用户基本信息
          username: "", //昵称
          name: "", //真实姓名
          avatar: "", //头像
          dedicated_email_address: "" //求职邮箱
        },
        editUserInfoState:false, //可编辑用户基本信息
        getUserInfoState:true,//获取用户基本信息的状态
        requestState:false,//接口请求的状态
        showUploadState:false, //上传图片
        identify: '', // 求职身份
        gender: '', // 性别
        currentIndex: 0,
        showPrivacy: false
      }
    },
    components:{
      leftPanel,
      portrait,
      cvNavbar,
      AccountSetting,
      AccountPrivacy,
      AccountOrder,
      EquipmentManagement
    },
    computed: {
      ...mapState('global', ['ossBeaseOptions']),
      ...mapState('app', ['alertData', 'updateOssOptions']),
      ...mapState('cv', ['cvs']),
      ...mapState('me', ['personInfo']),
    },
    created(){
      // 监听浏览器的地址变化
      if (window.history && window.history.pushState) {
        // 向历史记录中插入了当前页
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }
      this.getCvListData()
      this.currentIndex = parseInt(this.$route.query.index) || 0
      this._c_t = get_tUser().c_t || '';
      this.initOssBease()
      //检查是否登录
      auth((info)=>{
        if(!info.publicKey && !info.Authorization){
          //未登录
          routerTo('/signin?type=login')
          return false;
        }
        //获取用户基本信息
        this.getUsersBasicInfo();
      })
    },
    destroyed() {
      // 关闭事件监听
      window.removeEventListener('popstate', this.goBack, false);
    },
    methods: {
      ...mapActions('global', [ 'getOssBeaseOptions']),
      ...mapActions('cv', ['getCvsList']),
      ...mapActions('me', ['setUserPersonInfo']),
      // 监听浏览器的前进后退
      goBack() {
        this.currentIndex = parseInt(this.$route.query.index) || 0;
      },
      async getCvListData() {
        try {
          await this.getCvsList()
          this.showPrivacy = !!(this.cvs.filter(item => item.can_editable && !item.is_mentor && item.lang === 'cn').length)
          console.log(this.showPrivacy, 'showPrivacy==>>')
        } catch(e) {
          console.log(e)
        }
      },
      // 切换标签
      toTab(index) {
        history.pushState({}, '', `/account/users?index=${index}`)
        this.currentIndex = index;
      },
      //获取用户基本信息
      async getUsersBasicInfo(){
        this.getUserInfoState = true;
        let {c_t} = get_tUser()
        let res = await api.account.getUsersBasicInfo(c_t,{})
        if(res.code === 1000){
          let { username, name, avatar } = res.data;
          this.userInfoBackup = JSON.parse(JSON.stringify(res.data));
          this.userInfo = res.data;
          if(!username || !name || !avatar ){
            this.editUserInfoState = true;
          }else{
            this.editUserInfoState = false;
          }
          this.getUserInfoState = false;
        }

        // 获取用户信息
        res = await api.cvsV2.getBasicInfo(this._c_t);
        this.gender = res.data.gender || '';
        if(!this.gender) this.editUserInfoState = true;

        // 求职身份
        res = await api.cvsV2.getIdentifyInfo(this._c_t);
        this.identify = res.data.status;
        if(!this.identify) this.editUserInfoState = true;

      },
      //保存用户基本信息
      async saveUsersBasicInfo(){
        console.log(this.userInfo)
        let { name, username, avatar } = this.userInfo;
        let avatar_urlBackup = this.userInfoBackup.avatar;
        if(!avatar){
          this.$message({
            message: '请上传头像',
            type: 'warning'
          });
          return false;
        }
        if(!name){
          this.$message({
            message: '请填写姓名',
            type: 'warning'
          });
          return false;
        }
        if(!this.gender){
          this.$message({
            message: '请选择性别',
            type: 'warning'
          });
          return false;
        }
        if(!this.identify){
          this.$message({
            message: '请选择身份',
            type: 'warning'
          });
          return false;
        }
        // if(!username){
        //   this.$message({
        //     message: '请填写昵称',
        //     type: 'warning'
        //   });
        //   return false;
        // }
        if(this.requestState){
          return false;
        }
        this.requestState = true;
        let query = { name, username, gender: this.gender };

        if(avatar_urlBackup !== avatar){
          let logo_name = String(get_tUser().c_t) + ".png"
          let logo_url = String(avatar)
          let ossRes = {};
          let store = await oss(this.ossBeaseOptions);
          //调用
          var blob = dataURLtoBlob(logo_url);
          var fileData = blobToFile(blob, logo_name);
          try {
            ossRes = await store.put(`cv/cv_accounts/avatars/${logo_name}`, fileData)
          } catch (error) {
            this.isAdd = false;
            this.$message.error('图片上传失败');
            return false;
          }
          if (ossRes.res.statusCode !== 200) {
            this.isAdd = false;
            this.$message.error('图片上传失败');
            return false;
          }
          query.avatar_url = ossRes.url;
        }
        this.changeUserIdentify(query)
      },
      // 更新基本信息请求
      async changeUserIdentify(query) {
        try {
          let res = await api.cvsV2.setIdentifyInfo(this._c_t, {status: this.identify})
          if (res.code === 1000) {
            let is_student = null
            switch (this.identify) {
              case 'student': is_student = true; break;
              case 'already_work': is_student = false; break;
            }
            this.setUserPersonInfo({...this.personInfo, is_student})
            // this.$store.commit('app/GET_INFO', {...this.personInfo, is_student})
            api.me.updateUserInfo(this._c_t, query).then(res=>{
              this.requestState = false;
              if(res.code === 1000){
                this.$message({
                  message: '保存基本信息成功',
                  type: 'success',
                  duration:1500
                });
                this.editUserInfoState = false;
              }else{
                this.$message({
                  message: res.message,
                  type: 'error',
                  duration:1500
                });
              }
            })
          } else {
            this.$message.error('更新身份失败，请重试')
          }
        } catch (e) {

        }
      },

      //【上传】关闭
      uploadState(state){
        this.showUploadState = state;
      },
      initOssBease () {
        this.getOssBeaseOptions()
        //十分钟重新获取一次
        let ossTimeIndex = 10
        ossTimeName = setInterval(() => {
          if (ossTimeIndex <= 0) {
            //清除定时器
            clearInterval(ossTimeName)
            //重新获取oss参数
            this.initOssBease()
          }
          ossTimeIndex -= 1
        }, 60000)
      },
      //【上传】上传图片成功
      uploadConfirm(file){
        this.userInfo.avatar = file;
        this.uploadState(false)
      },

    }
  }
</script>
<style scoped lang="scss">
  // 公共初始化样式
  @import '~/assets/css/public';
  @import './users.scss';
</style>
<style lang="scss">
.account-user-main {
  .el-select {
    width: 186px;
    height: 40px;
  }
}
</style>
